import classNames from "classnames";
import { PropsWithChildren } from "react";
import { Link } from "react-router";
import ArrowLeftAlt from "../components/icons/arrow_left_alt.svg?react";
import styles from "./Header.module.css";
import Icon from "./Icon";
import NavTabs from "./NavTabs";

interface Link {
  to: string;
  text: string;
}

type Props = PropsWithChildren<{
  backLink?: string;
  heading?: string;
  subHeading?: string;
  tabs?: Link[];
}>;

const Header = ({ backLink, heading, subHeading, tabs, children }: Props) => {
  return (
    <>
      <header
        className={classNames(styles.header, {
          [styles.hasNavTabs]: tabs !== undefined,
        })}
      >
        {backLink && (
          <Link to={backLink}>
            <Icon className={styles.backIcon} glyph={ArrowLeftAlt} />
          </Link>
        )}
        <div className={styles.heading}>
          {heading}
          {subHeading && (
            <span className={styles.subHeading}>{subHeading}</span>
          )}
        </div>
        <div className={styles.controls}>{children}</div>
      </header>
      {tabs && (
        <div className={styles.tabs}>
          <NavTabs tabs={tabs} />
        </div>
      )}
    </>
  );
};

export default Header;
